<div style="display: flex; flex-direction: column; width: 100%; height: 100%;" data-cy="erx-container">
  <div style="flex-basis: 40px; min-height: 40px;" data-cy="erx-header">
    <div style="display: flex;" data-cy="erx-header-content">
      <mat-icon svgIcon="medicine" class="mr-2" style="margin-top: -2px" data-cy="erx-medicine-icon"></mat-icon>
      <h5 class="mr-3" data-cy="erx-patient-info">{{globals.currentPatientFullName}}
        (Age: {{moment().diff(globals.ThePatient?.BirthDate??undefined, 'years')}})</h5>
      <mat-icon svgIcon="patientValidationWithIssue" class="mr-2" style="margin-top: -2px"
        *ngIf="!isValidPatient" data-cy="erx-patient-invalid-icon"></mat-icon>
      <mat-icon svgIcon="patientValidationApproved" class="mr-2" style="margin-top: -2px"
        *ngIf="isValidPatient" data-cy="erx-patient-valid-icon"></mat-icon><span data-cy="erx-loading-text">{{isLoading ? 'Loading...' : ''}}</span>
      <div style="flex: 1;"></div>
      <button mat-raised-button class="tdo-button" style="margin-right: 5px" matTooltip="Reports"  [disabled]="isLoading"
        (click)="onOpenErxReport()" *ngIf="!popupVisible &&!showFixPrescription" data-cy="erx-reports-button">
        <span class="material-icons-outlined">
          summarize
        </span>
      </button>
      <!-- <button mat-raised-button class="tdo-button" style="margin-right: 5px" [matBadge]="queuedRx"
        matTooltip="Errors & Approvals" matBadgePosition="after" matBadgeColor="warn" (click)="onOpenErx()"
        *ngIf="!popupVisible &&!showFixPrescription">
        <span class="material-icons-outlined">assignment_late</span>
      </button> -->
      <button mat-raised-button class="tdo-close" matTooltip="Open eRX" (click)="onOpenErx4Patient()"  [disabled]="isLoading"
        *ngIf="!popupVisible &&!showFixPrescription" data-cy="erx-prescribe-button">
        Prescribe +
      </button>
      <button mat-raised-button *ngIf="showFixPrescription && caseFormControl.value && caseWorkItemFormControl.value"  [disabled]="isLoading"
        class="tdo-button" style="margin-right: 5px" (click)="onUpdatePrescription()" data-cy="erx-save-changes-button">
        Save Changes
      </button>
      <button mat-raised-button *ngIf="popupVisible || showFixPrescription" class="tdo-close" [disabled]="isLoading"
        (click)="closePopUp()" data-cy="erx-return-button">
        Return
      </button>
    </div>
  </div>
  <div style="flex: 1; overflow: hidden; max-height: 100%;" data-cy="erx-content">
    <!-- Actual Data -->
    <div style="flex: 1; flex-direction: row; height:100%; max-height: 100%; overflow: hidden" *ngIf="!popupVisible" data-cy="erx-prescription-view">

      <div class="center" *ngIf="isLoading" data-cy="erx-loading-container">
        <mat-progress-spinner diameter=100 mode="indeterminate" color="accent" data-cy="erx-loading-spinner">
        </mat-progress-spinner>
      </div>
      <!-- Prescription Listing -->
      <tdo-table #prescriptionTable *ngIf="!isLoading && prescriptions" [dataSource]="prescriptions" noDataMessage="No prescriptions found"
        [isSearchable]="true" [searchPredicate]="searchPredicate" (rowSelected)="onFixPrescription($event)" data-cy="erx-prescription-table">
        <tdo-table-column displayName="Reference" propertyName="reference" isSortable="true" [rowTemplate]="reference" data-cy="erx-reference-column">
          <ng-template #reference let-row>
            <div style="max-width: 150px;" *ngIf="!showFixPrescription || this.selectedPrescriptionToFix !== row.model" data-cy="erx-reference-value-{{row.index}}">
              {{row.model?.reference}}
            </div>
            <div style="max-width: 150px"
              *ngIf="this.selectedPrescriptionToFix !== row.model && row.model.reference?.trim() === ''" data-cy="erx-reference-general-{{row.index}}">
              General
            </div>
            <div style="max-width: 150px" *ngIf="showFixPrescription" data-cy="erx-reference-edit-{{row.index}}">
              <mat-form-field *ngIf="showFixPrescription && this.selectedPrescriptionToFix === row.model" data-cy="erx-case-form-field">
                <mat-select [placeholder]="selectedPrescriptionToFix.reference"
                  [formControl]="caseFormControl" (selectionChange)="onCaseSelection4Fix()" data-cy="erx-case-select">
                  <mat-option *ngFor="let case of patientCaseList4Fix; let i = index" [value]="case.PatientCaseId" data-cy="erx-case-option-{{i}}">
                    {{case.Description}}
                  </mat-option>
                </mat-select>

              </mat-form-field>
              <br>
              <mat-form-field
                *ngIf="caseWorkItemList4Fix && showFixPrescription && this.selectedPrescriptionToFix === row.model" data-cy="erx-work-item-form-field">
                <mat-select placeholder="Case Work Item" [formControl]="caseWorkItemFormControl" data-cy="erx-work-item-select">
                  <mat-option *ngFor="let caseWorkItem of caseWorkItemList4Fix; let i = index" [value]="caseWorkItem.CaseWorkItemId" data-cy="erx-work-item-option-{{i}}">
                    {{caseWorkItem.Description}}
                  </mat-option>
                </mat-select>

              </mat-form-field>
            </div>
          </ng-template>
        </tdo-table-column>
        <tdo-table-column displayName="Date" propertyName="date" isSortable="true" [rowTemplate]="date" data-cy="erx-date-column">
          <ng-template #date let-row>
            <div style="max-width: 180px;" data-cy="erx-date-value-{{row.index}}">
              {{row.model?.prescriptionDate | date:'MM/dd/yyyy'}}
            </div>
          </ng-template>
        </tdo-table-column>
        <tdo-table-column displayName="Dispense" propertyName="dispenseUnit" [rowTemplate]="dispense" data-cy="erx-dispense-column">
          <ng-template #dispense let-row>
            <div style="max-width: 160px; text-align: center" data-cy="erx-dispense-value-{{row.index}}">
              {{row.model?.dispenseQuantity}} {{row.model.dispenseUnit}}
            </div>
          </ng-template>
        </tdo-table-column>
        <tdo-table-column displayName="Medication" propertyName="medication" isSortable="true"
          [rowTemplate]="medication" data-cy="erx-medication-column">
          <ng-template #medication let-row>
            <div style="max-width: 160px; text-align: center" data-cy="erx-medication-value-{{row.index}}">
              {{row.model?.medication}}
            </div>
          </ng-template>
        </tdo-table-column>
        <tdo-table-column displayName="Dosage" propertyName="dosage" [rowTemplate]="dosage" data-cy="erx-dosage-column">
          <ng-template #dosage let-row>
            <div style="max-width: 160px;" data-cy="erx-dosage-value-{{row.index}}">
              {{row.model?.dosage}} {{row.model.dosageForm}}
            </div>
          </ng-template>
        </tdo-table-column>
        <tdo-table-column displayName="Directions" propertyName="directions" [rowTemplate]="directions" data-cy="erx-directions-column">
          <ng-template #directions let-row>
            <div style="max-width: 160px;" data-cy="erx-directions-value-{{row.index}}">
              {{row.model?.directions}}
            </div>
          </ng-template>
        </tdo-table-column>
        <tdo-table-column displayName="Refill" propertyName="refill" [rowTemplate]="refill" data-cy="erx-refill-column">
          <ng-template #refill let-row>
            <div style="max-width: 160px;" data-cy="erx-refill-value-{{row.index}}">
              {{row.model?.refill}}
            </div>
          </ng-template>
        </tdo-table-column>
        <tdo-table-column displayName="Prescriber" propertyName="doctorName" isSortable="true" [rowTemplate]="doctor" data-cy="erx-prescriber-column">
          <ng-template #doctor let-row>
            <div style="max-width: 160px;" data-cy="erx-prescriber-value-{{row.index}}">
              {{row.model?.doctorName}}
            </div>
          </ng-template>
        </tdo-table-column>
        <tdo-table-column displayName="Pharmacy" propertyName="pharmacy" isSortable="true" [rowTemplate]="pharmacy" data-cy="erx-pharmacy-column">
          <ng-template #pharmacy let-row>
            <div style="max-width: 160px;" data-cy="erx-pharmacy-value-{{row.index}}">
              ({{row.model?.eRxPharmacyID}}) {{row.model?.eRxPharmacyName}}
            </div>
          </ng-template>
        </tdo-table-column>
        <tdo-table-column displayName="Pharm #" propertyName="pharmacyPhoneNumber" [rowTemplate]="pharmacyphone" data-cy="erx-pharmacy-phone-column">
          <ng-template #pharmacyphone let-row>
            <div style="max-width: 160px;" data-cy="erx-pharmacy-phone-value-{{row.index}}">
              <u><a [href]="'tel:' + row.model?.pharmacyPhoneNumber" data-cy="erx-pharmacy-phone-link-{{row.index}}">{{row.model?.pharmacyPhoneNumber}}</a></u>
              <span *ngIf="row.model.pharmacyPhoneNumber === '' || !row.model.pharmacyPhoneNumber" data-cy="erx-pharmacy-phone-unavailable-{{row.index}}">not avail</span>
            </div>
          </ng-template>
        </tdo-table-column>
      </tdo-table>

    </div>


    <!-- Popup -->
    <div *ngIf="popupVisible" style="flex: 1; flex-direction: row; height: 100%; width: 100%; overflow: auto" data-cy="erx-popup-container">

      <div class="{{showFixPrescription ? 'h-85' : 'h-95'}}" style="width: 100%" data-cy="erx-popup-content">
        <app-doctors *ngIf="showDoctor" data-cy="erx-doctors-component"></app-doctors>

        <iframe #iframe *ngIf="showIFrame" style="height: 100%; width: 100%; border:none !important;" title="eRX Screen" data-cy="erx-iframe"></iframe>

        <div class="center" data-cy="erx-iframe-loading-container">
          <mat-progress-spinner diameter=100 *ngIf="showIFrame && !iFrameLoaded" mode="indeterminate" color="accent" data-cy="erx-iframe-loading-spinner">
          </mat-progress-spinner>
        </div>

        <div *ngIf="iframeLoadError && errorMessage?.length>0" class="center" data-cy="erx-error-container">
          <h4 style="color: red" data-cy="erx-error-message">Error loading eRX<br/> {{errorMessage}}</h4>
      </div>
    </div>
  </div>
</div>